<template>
  <container>
      <div class="my-16 flex justify-center items-center" style="min-height: 400px;">
       <div>
          <div class="mb-12">
            <svg class="w-full" style="max-width: 482px" height="211" viewBox="0 0 482 211" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M127.156 130.938H150.359V163.703H127.156V208H86.5156V163.703H2.5625L0.734375 138.109L86.0938 3.25H127.156V130.938ZM41.2344 130.938H86.5156V58.6562L83.8438 63.2969L41.2344 130.938ZM310.109 123.344C310.109 151.656 304.25 173.312 292.531 188.312C280.812 203.312 263.656 210.812 241.062 210.812C218.75 210.812 201.688 203.453 189.875 188.734C178.062 174.016 172.016 152.922 171.734 125.453V87.7656C171.734 59.1719 177.641 37.4687 189.453 22.6562C201.359 7.84375 218.469 0.4375 240.781 0.4375C263.094 0.4375 280.156 7.79687 291.969 22.5156C303.781 37.1406 309.828 58.1875 310.109 85.6562V123.344ZM269.469 82C269.469 65.0312 267.125 52.7031 262.438 45.0156C257.844 37.2344 250.625 33.3438 240.781 33.3438C231.219 33.3438 224.141 37.0469 219.547 44.4531C215.047 51.7656 212.656 63.25 212.375 78.9062V128.688C212.375 145.375 214.625 157.797 219.125 165.953C223.719 174.016 231.031 178.047 241.062 178.047C251 178.047 258.172 174.156 262.578 166.375C266.984 158.594 269.281 146.688 269.469 130.656V82ZM457.906 130.938H481.109V163.703H457.906V208H417.266V163.703H333.312L331.484 138.109L416.844 3.25H457.906V130.938ZM371.984 130.938H417.266V58.6562L414.594 63.2969L371.984 130.938Z" fill="#00BFBC"/>
            </svg>
          </div>

         <head-line :level="1" :size="1" :bold="true" class="text-center mb-8">{{ $t('pages.notfound.headline') }}</head-line>
         <div class="mt-6 w-full lg:flex lg:justify-center">
            <button 
            @click="handleBack"
            class="block w-full mb-5 lg:mb-0 lg:mx-2 text-center lg:w-auto px-4 py-2 border border-transparent rounded select-none bg-awro-600 text-awro-100 hover:bg-awro-500 focus:bg-awro-700 focus:outline-none focus:shadow-none">
                {{ $t('btn.back') }}
            </button>
            <router-link to="/" class="block lg:mx-2 text-center px-4 py-2 border border-transparent rounded select-none bg-support-500 text-awro-100 hover:bg-support-300 focus:bg-support-700 focus:outline-none">
                {{ $t('nav.home') }}
            </router-link>
            </div>
       </div>
      </div>
  </container>
</template>

<script>
import Container from '@/components/Container'
import HeadLine from '@/components/theme/HeadLine'
export default {
    name: 'NotFound',
    components: {Container,HeadLine},
    beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from;
    })
  },
    data() {
        return {
            fromRoute: null
        }
    },
    methods: {
        handleBack() {
            if(this.fromRoute && this.fromRoute.name) {
                    this.$router.push({name: this.fromRoute.name});
                    return;
            }
             this.$router.back();
        }
    }
}
</script>

<style>

</style>